module.exports = __webpack_public_path__ + "static/media/ai_gbt.c099a1cd.svg";